import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['type', 'discountPercentageInput', 'discountInput', 'inputContainer']


  change() {
    let input
    switch(this.typeTarget.value) {
    case 'percentage':
      input = this.discountPercentageInputTarget.innerHTML
      break;
    case 'value':
      input = this.discountInputTarget.innerHTML
      break;
    }

    $(this.inputContainerTarget).html(input)
  }
}
